import CancelIcon from "@mui/icons-material/Cancel";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";

import { useShipperShipmentPageContext } from "hooks";

interface Props {
  onOpenCancelShipmentBooking: () => void;
}

export function CancelShipmentBookingSideBarMenuOption(props: Props) {
  const { onOpenCancelShipmentBooking } = props;
  const { shipment } = useShipperShipmentPageContext();

  if (
    !shipment ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT" ||
    shipment.shipment_status !== "BOOKED" ||
    (shipment.access_type !== "OWNER" && shipment.access_type !== "ADMIN")
  ) {
    return null;
  }

  return (
    <ListItem>
      <Tooltip
        followCursor
        title={
          <Typography variant="body1">
            Cancels a shipment after booking. The shipment will no longer be
            listed under booked shipments.
          </Typography>
        }
      >
        <ListItemButton onClick={onOpenCancelShipmentBooking}>
          <ListItemIcon>
            <CancelIcon />
          </ListItemIcon>
          <ListItemText primary="Cancel Booking" />
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
}
